import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Agiractmodal from './agiractmodal'
import {
  fetchAgirAct,
  clearAgirAct,
  fetchListaCausasFalha,
  submitPadronizarAct,
  submitPivotarAct,
  submitEscalonarAct,
  submitEncerrarAct
} from './redux/agiractActions'
import './agiract.scss'

const Agiract = ({
  open,
  close,
  planoId,
  onSuccess = () => {}
}) => {
  const dispatch = useDispatch()

  const { sistema } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const {
    loading,
    submitting,
    loadingCausas,
    data,
    causasFalha,
    error
  } = useSelector(state => state.pdcaState.pdcaAgirActState)

  useEffect(() => {
    if (open && planoId) {
      dispatch(fetchAgirAct(planoId))
    }
  }, [dispatch, open, planoId])

  useEffect(() => {
    if (!open) {
      dispatch(clearAgirAct())
    }
  }, [dispatch, open])

  useEffect(() => {
    if (open && error && !loading && !submitting) {
      dispatch(clearAgirAct())
      close()
    }
  }, [dispatch, open, error, loading, submitting, close])

  const handleClose = () => {
    dispatch(clearAgirAct())
    close()
  }

  const handlePadronizar = async comentario => {
    const result = await dispatch(
      submitPadronizarAct({
        planoId,
        comentario
      })
    )

    if (result?.ok) {
      handleClose()
      onSuccess()
    }
  }

  const handleAbrirPivotar = async () => {
    if (causasFalha?.length) {
      return causasFalha
    }

    return dispatch(fetchListaCausasFalha())
  }

  const handlePivotar = async ({ causaFalhaId, comentario }) => {
    const result = await dispatch(
      submitPivotarAct({
        planoId,
        causaFalhaId,
        comentario
      })
    )

    if (result?.ok) {
      handleClose()
      onSuccess()
    }
  }

  const handleAbrirEscalonar = async () => {
    if (causasFalha?.length) {
      return causasFalha
    }

    return dispatch(fetchListaCausasFalha())
  }

  const handleEscalonar = async ({ causaFalhaId, comentario }) => {
    const result = await dispatch(
      submitEscalonarAct({
        planoId,
        causaFalhaId,
        comentario
      })
    )

    if (result?.ok) {
      handleClose()
      onSuccess()
    }
  }

  const handleAbrirEncerrar = async () => {
    if (causasFalha?.length) {
      return causasFalha
    }

    return dispatch(fetchListaCausasFalha())
  }

  const handleEncerrar = async ({ causaFalhaId, comentario }) => {
    const result = await dispatch(
      submitEncerrarAct({
        planoId,
        causaFalhaId,
        comentario
      })
    )

    if (result?.ok) {
      handleClose()
      onSuccess()
    }
  }

  return (
    <Agiractmodal
      open={open}
      close={handleClose}
      loading={loading}
      submitting={submitting}
      loadingCausas={loadingCausas}
      data={data}
      causasFalha={causasFalha}
      nls={nls}
      onPadronizar={handlePadronizar}
      onAbrirPivotar={handleAbrirPivotar}
      onPivotar={handlePivotar}
      onAbrirEscalonar={handleAbrirEscalonar}
      onEscalonar={handleEscalonar}
      onAbrirEncerrar={handleAbrirEncerrar}
      onEncerrar={handleEncerrar}
    />
  )
}

export default Agiract